import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DeleteForeverIcon(props: IconProps) {
    return <Icon {...props} iconKey={"delete_forever"}/>
}
